module.exports = __webpack_public_path__ + "img/hr-tutorial-grid1.edaef520.png";